import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "../lib/theme";

/**
 * Animated sun ⇄ moon toggle. The two icons are stacked in the same slot; the
 * inactive one is rotated + scaled out, and the incoming one rotates + scales
 * in for a smooth crossfade.
 */
export default function ThemeToggle({ size = "md", testId = "theme-toggle-btn" }) {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";
  const dim = size === "sm" ? "w-9 h-9" : "w-10 h-10";
  const icon = size === "sm" ? "w-4 h-4" : "w-[18px] h-[18px]";
  return (
    <button
      onClick={toggle}
      data-testid={testId}
      aria-label={`Switch to ${isDark ? "light" : "dark"} mode`}
      className={`${dim} relative rounded-full border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 grid place-items-center text-slate-700 dark:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-700 hover:scale-105 active:scale-95 transition-[transform,background-color] duration-200 overflow-hidden`}
    >
      <span
        key={isDark ? "sun" : "moon"}
        className="absolute inset-0 grid place-items-center theme-icon-enter"
      >
        {isDark ? <Sun className={`${icon} text-amber-400`} /> : <Moon className={`${icon} text-slate-600 dark:text-slate-300`} />}
      </span>
      {/* Subtle ambient glow */}
      <span
        aria-hidden="true"
        className={`absolute inset-0 rounded-full pointer-events-none transition-opacity duration-300 ${
          isDark ? "opacity-100 bg-amber-400/10" : "opacity-0"
        }`}
      />
    </button>
  );
}
